export default import.meta.ROLLDOWN_FILE_URL_r5hy8ZMPkh$CnSqWqJSrpA